import toast from "react-hot-toast";
import customFetch from "../hooks/fetchWrapper";

// Create a new emirate
export const createEmirate = async (formBody) => {
  return toast.promise(
    customFetch("emirates", {
      method: "POST",
      body: JSON.stringify([formBody]),
    }),
    {
      loading: "Creating emirate...",
      success: (data) => `${data.message}`,
      error: "Failed to create emirate",
    }
  );
};

// Update an existing emirate
export const updateEmirate = async (id, formBody) => {
  return toast.promise(
    customFetch(`emirates/${id}`, {
      method: "PUT",
      body: JSON.stringify(formBody),
    }),
    {
      loading: "Updating emirate...",
      success: (data) => `${data.message}`,
      error: "Failed to update emirate",
    }
  );
};

// Delete an emirate
export const deleteEmirate = async (id) => {
  return toast.promise(
    customFetch(`emirates/${id}`, {
      method: "DELETE",
    }).then((response) => {
      if (typeof response === "object") {
        return response;
      } else {
        return { status: true, message: "Delete successful" };
      }
    }),
    {
      loading: "Deleting emirate...",
      success: (data) => `${data.message}`,
      error: "Failed to delete emirate",
    }
  );
};

// Fetch all emirates
export const getAllEmirates = async () => {
  try {
    const response = await customFetch("emirates", {
      method: "GET",
      // headers: {
      //   "ngrok-skip-browser-warning": "true",
      // },
    });
    console.log("🚀 ~ getAllEmirates ~ response:", response);
    return response;
  } catch (error) {
    console.error("Error fetching emirates:", error);
    throw error;
  }
};
